export const blockIconsCommunicationNotificationsActiveNew = (
	<span className='material-symbols-outlined'>notifications_active</span>
);
